const clockTimePattern = /^(?:[01]\d|2[0-3]):[0-5]\d$/

export function parseClockTime(value: string): string | null {
  const input = value.trim().replace(':', '')
  if (!/^\d{3,4}$/.test(input)) return null
  const compact = input.padStart(4, '0')
  const normalized = `${compact.slice(0, 2)}:${compact.slice(2)}`
  return clockTimePattern.test(normalized) ? normalized : null
}

export function clockTimeMinutes(value: string): number | null {
  const normalized = parseClockTime(value)
  if (!normalized) return null
  const [hours, minutes] = normalized.split(':').map(Number)
  return hours * 60 + minutes
}

export function clockDurationMinutes(startTime: string, endTime: string): number | null {
  const start = clockTimeMinutes(startTime)
  const end = clockTimeMinutes(endTime)
  if (start === null || end === null || start >= end) return null
  return end - start
}

export function clockTimeInputError(value: string): string | null {
  if (!value.trim()) return null
  return parseClockTime(value) ? null : 'Enter a time like 700 or 07:00.'
}

/**
 * Ids of entries that overlap another entry of the same person on the same day. Touching ranges
 * (one ends at 10:00, the next starts at 10:00) do not overlap.
 */
export function findOverlappingEntries(
  entries: { id: string; personId: string; workDate: string; startTime: string; endTime: string }[]
): Set<string> {
  const overlapping = new Set<string>()
  const groups = new Map<string, typeof entries>()
  for (const entry of entries) {
    const key = `${entry.personId} ${entry.workDate}`
    groups.set(key, [...(groups.get(key) ?? []), entry])
  }
  for (const group of groups.values()) {
    const sorted = [...group].sort((left, right) => left.startTime.localeCompare(right.startTime))
    let latest = sorted[0]
    for (const entry of sorted.slice(1)) {
      if (entry.startTime < latest.endTime) {
        overlapping.add(entry.id)
        overlapping.add(latest.id)
      }
      if (entry.endTime > latest.endTime) latest = entry
    }
  }
  return overlapping
}
